import Footer from 'components/Footer'
import Header from 'pages/Home1/Header'
import React from 'react'
import WashtaLogo from '../../assets/images/WashtaLogo.png'
import { useNavigate } from 'react-router-dom'
const NotVerifiedUser = () => {
   const navigate = useNavigate()
  return (
    <>
         <Header btnText="Become a Partner" btnLink={()=>navigate("/become-a-partner")} />

    <div style={{ position: 'relative',height:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div>
            <img src={WashtaLogo} className='image-div-class-not-verify'/>
            <h1 style={{textAlign:'center'}} className='h1-all-heading'>Your application has been received and is currently under review. We'll notify you via email once it's approved 
        <br/>
        <span style={{color:'#6b5fe4',fontFamily:'"Manrope", sans-serif',paddingTop:10}}>Thank you for  your interest!</span>
        </h1>
        </div>
        
        </div>
        <Footer/>
        </>
  )
}

export default NotVerifiedUser